import React from 'react';
import { BriefcaseMedical, Landmark, HeartPulse } from 'lucide-react';
import { FadeInUp } from './FadeInUp';
const painPoints = [{
  icon: <BriefcaseMedical className="w-10 h-10 text-vitality-green" data-id="element-130" />,
  text: 'Si mañana no puedes trabajar… ¿tu familia aguanta 3 meses?',
  number: '01'
}, {
  icon: <Landmark className="w-10 h-10 text-vitality-green" data-id="element-131" />,
  text: '¿Tu banco está construyendo tu retiro… o solo guardando tu dinero sin hacer nada?',
  number: '02'
}, {
  icon: <HeartPulse className="w-10 h-10 text-vitality-green" data-id="element-132" />,
  text: 'Si algo grave pasa con tu salud… ¿tienes un plan o solo esperanza?',
  number: '03'
}];
export function PainPoints() {
  return <section className="bg-light-gray py-24 relative" data-id="element-133">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-134">
        <FadeInUp data-id="element-135">
          <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-136">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-deep-blue mb-6 tracking-tight" data-id="element-137">
              Antes de cerrar esta página… respóndete esto:
            </h2>
            <div className="w-24 h-1.5 bg-vitality-green mx-auto rounded-full" data-id="element-138"></div>
          </div>
        </FadeInUp>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-139">
          {painPoints.map((point, index) => <FadeInUp key={index} delay={index * 0.1} data-id="element-140">
              <div className="bg-white p-10 rounded-2xl shadow-sm border-l-4 border-l-vitality-green border-y border-r border-gray-100 flex flex-col h-full hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 relative overflow-hidden group" data-id="element-141">
                <div className="absolute -right-4 -top-4 text-[8rem] font-black text-gray-50 opacity-50 group-hover:text-vitality-green/5 transition-colors duration-300 pointer-events-none leading-none" data-id="element-142">
                  {point.number}
                </div>
                <div className="flex-shrink-0 bg-green-50 w-20 h-20 flex items-center justify-center rounded-2xl mb-8 relative z-10" data-id="element-143">
                  {point.icon}
                </div>
                <p className="text-gray-800 text-xl leading-relaxed font-semibold relative z-10" data-id="element-144">
                  {point.text}
                </p>
              </div>
            </FadeInUp>)}
        </div>

        <FadeInUp delay={0.4} data-id="element-145">
          <div className="mt-20 text-center" data-id="element-146">
            <div className="inline-block bg-deep-blue text-white px-8 py-4 rounded-full shadow-lg" data-id="element-147">
              <p className="text-lg md:text-xl font-medium tracking-wide" data-id="element-148">
                Si alguna de estas preguntas te incomodó… necesitas esta
                asesoría.
              </p>
            </div>
          </div>
        </FadeInUp>
      </div>
    </section>;
}